import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { Button } from '../button/button.component';
import { Card } from '../card/card.component';

@Component({
  selector: 'procure-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  imports: [Button, RouterLink, Card, QuicklinkDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageNotFound {
  @Input() redirectUrl: string = '/';
  @Input() redirectLabel: string = 'Go to Dashboard';
}
